import { createResourceKeys } from "@/lib/resource-context";

export const catalogKeys = createResourceKeys("tool_catalog");
